import React from 'react';
import { Link } from 'react-router-dom';
import { ForgotPasswordProps } from './types';
import styles from './ForgotPassword.module.css';

export const ForgotPassword: React.FC<ForgotPasswordProps> = ({
  email,
  setEmail,
  isLoading,
  isSubmitted,
  handleSubmit
}) => {
  return (
    <div className={styles['forgot-password-container']}>
      <form 
        className={styles['forgot-password-form']} 
        onSubmit={handleSubmit}
        data-testid="forgot-password-form"
      >
        <h2 className={styles['forgot-password-title']}>パスワードをお忘れですか？</h2>
        
        {!isSubmitted ? (
          <>
            <p className={styles['forgot-password-subtitle']}>
              パスワードのリセットが必要な場合は、システム管理者にお問い合わせください。
              管理者が一時パスワードを発行します。
            </p>

            <div className={styles['forgot-password-form-group']}>
              <label htmlFor="email" className={styles['forgot-password-form-label']}>メールアドレス</label>
              <div className={styles['forgot-password-input-container']}>
                <svg
                  className={styles['forgot-password-input-icon']}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                >
                  <path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <input
                  id="email"
                  type="email"
                  className={styles['forgot-password-form-input']}
                  placeholder="your-email@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-password-email-input"
                />
              </div>
            </div>

            <button
              type="submit"
              className={styles['forgot-password-submit-button']}
              disabled={isLoading}
              data-testid="forgot-password-submit-button"
            >
              {isLoading ? (
                <span className={styles['forgot-password-loading-spinner']}></span>
              ) : '送信'}
            </button>
          </>
        ) : (
          <div className={styles['forgot-password-success-message']}>
            <svg
              className={styles['forgot-password-success-icon']}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="48"
              height="48"
            >
              <path fill="#4CAF50" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <p className={styles['forgot-password-success-text']}>
              リクエストを受け付けました。<br />
              パスワードのリセットが必要な場合は、管理者にお問い合わせください。
            </p>

            <Link to="/login">
              <button
                type="button"
                className={styles['forgot-password-secondary-button']}
                data-testid="forgot-password-login-button"
              >
                ログイン画面に戻る
              </button>
            </Link>
          </div>
        )}
        
        <div className={styles['forgot-password-auth-footer']}>
          <p className={styles['forgot-password-auth-footer-text']}>
            <Link to="/login" className={styles['forgot-password-auth-link']}>
              ログイン画面に戻る
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
}; 